import { Box, BoxProps, Text } from "@chakra-ui/react";
import { DeveloperModeIcon } from "./developer-mode-icon";

type DeveloperBoxProps = BoxProps & {
  children: React.ReactNode;
};

export function DeveloperBox({ children, ...props }: DeveloperBoxProps) {
  return (
    <Box border="1px solid" borderColor="gray.100" borderRadius="8px" p={4} {...props}>
      <Text fontWeight="medium" fontSize="sm" mb={4}>
        Developer Settings <DeveloperModeIcon />
      </Text>
      {children}
    </Box>
  );
}
